export const SPATIAL_OPERATIONS_PATH = '/spatial-operations';

export const SPATIAL_OPERATIONS_MODES = ['camera', 'spatial', 'history'] as const;

export type SpatialOperationsMode = (typeof SPATIAL_OPERATIONS_MODES)[number];

function text(value: unknown): string {
  return String(value || '').trim();
}

export function parseSpatialOperationsMode(value: unknown): SpatialOperationsMode {
  const mode = text(value).toLowerCase();
  if (mode === 'spatial' || mode === 'history') return mode;
  return 'camera';
}

export function parseSpatialOperationsSearch(search: string): {
  siteId: string;
  cameraId: string | null;
  conditionId: string | null;
  mode: SpatialOperationsMode;
} {
  const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
  return {
    siteId: text(params.get('site_id') || params.get('site')),
    cameraId: text(params.get('camera_id')) || null,
    conditionId: text(params.get('condition_id')) || null,
    mode: parseSpatialOperationsMode(params.get('mode')),
  };
}

export function buildSpatialOperationsPath(args: {
  siteId?: string | null;
  cameraId?: string | null;
  conditionId?: string | null;
  mode?: SpatialOperationsMode | null;
  currentSearch?: string;
}): string {
  const current = new URLSearchParams(
    String(args.currentSearch || '').startsWith('?')
      ? String(args.currentSearch).slice(1)
      : String(args.currentSearch || ''),
  );
  const siteId = text(args.siteId) || text(current.get('site_id') || current.get('site'));
  const cameraId = args.cameraId === undefined ? text(current.get('camera_id')) : text(args.cameraId);
  const conditionId = args.conditionId === undefined
    ? text(current.get('condition_id'))
    : text(args.conditionId);
  const mode = args.mode === undefined
    ? parseSpatialOperationsMode(current.get('mode'))
    : parseSpatialOperationsMode(args.mode);

  const next = new URLSearchParams();
  current.forEach((value, key) => {
    if (key === 'site' || key === 'site_id' || key === 'camera_id' || key === 'condition_id' || key === 'mode') {
      return;
    }
    next.set(key, value);
  });
  if (siteId) next.set('site_id', siteId);
  if (cameraId) next.set('camera_id', cameraId);
  if (conditionId) next.set('condition_id', conditionId);
  if (mode && mode !== 'camera') next.set('mode', mode);
  const query = next.toString();
  return query ? `${SPATIAL_OPERATIONS_PATH}?${query}` : SPATIAL_OPERATIONS_PATH;
}
